import React, { useEffect, useState } from "react";
import logo from "../../assets/profile.png";
import { fetchFeedback } from "../../action/feedbackAction";
import { PageInfoHeader } from "../../component/comman/PageInfoHeader";
import { fDateUTC } from "../../utils/helper/timeHelpers";
import Pagination from "../../comman/Pagination";

const Reviews = () => {

      const [total, setTotal] = useState(0);
      const [page, setPage] = useState(1);
      const limit = 10;
      const [search, setSearch] = useState("");
      const [debouncedSearch, setDebouncedSearch] = useState("");
      const [review, setReview] = useState([]);

     const fetchReviewListing = async () => {
        try {
          const resp = await fetchFeedback({
            page: page - 1,
            limit,
            search: debouncedSearch
          });
          if (resp?.data?.rows) {
            setReview(resp.data.rows);
            setTotal(resp.data.total);
          }
        } catch (error) {
        
        }
      };


     useEffect(() => {
      fetchReviewListing();
    }, [page, debouncedSearch]);



    const renderStars = (rating = 0) => {
      return Array.from({ length: 5 }, (_, i) => (
        <i
          key={i}
          className={`fa-star ${i < rating ? "fa-solid text-orange" : "fa-regular text-orange"}`}
        />
      ));
    };


  return (
    <section className="content mb-5">
      <div className="container-fluid">
        <div className="row titlepad">
          <div className="col-md-12">
            <div className="mt-3 mb-3">
              <div className="dashbed-border-bottom"></div>
            </div>

            <div className="row align-items-end">
              <div className="col-sm-6">
                <h4>Reviews</h4>
                <PageInfoHeader
                  page={page}
                  limit={limit}
                  total={total || 0}
                  label="list of Reviews"
                />
                {/* <p className="page-sub-head">Showing 1 to 10 of 57 list</p> */}
                {/* <a href="#" className="btn-md btn-primary d-inline-block">
                  <i className="fa-regular fa-file-excel"></i> Export
                </a>
                <a
                  href="#"
                  data-toggle="modal"
                  data-target="#filter"
                  className="btn-md btn-dark d-inline-block"
                >
                  <i className="fa-solid fa-filter"></i> Filter
                </a> */}
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="mb-3">
              <div className="dashbed-border-bottom"></div>
            </div>
          </div>

          <div className="col-md-12">
            <div className="table-responsive bg-white">
              <table
                className="table table-striped table-bordered admintable border-0"
                cellspacing="0"
                cellpadding="0"
              >
            <tbody>
              <tr>
                <th>#</th>
                <th>Photo</th>
                <th>Name</th>
                <th>Review date and time</th>
                <th>Rating</th>
                <th>Service</th>
              </tr>

              {review.length === 0 ? (
                <tr>
                  <td colSpan="5" className="text-center">
                    No reviews found
                  </td>
                </tr>
              ) : (
                review.map((item, index) => (
                  <tr key={item._id}>
                    <td>{(page - 1) * limit + index + 1}</td>
                    <td>
                      <img
                        src={item.userPhoto || logo}
                        width="50"
                        alt="profile"
                        onError={(e) => (e.target.src = logo)}
                      />
                    </td>

                    <td>
                      <strong>{item.userName || "N/A"}</strong>
                      <br />
                      {item.userPhone || ""}
                    </td>

                    <td>{fDateUTC(item.createdAt)}</td>

                    <td>{renderStars(item.rating)}</td>
                    <td>{item.serviceName || '' }</td>
                  </tr>
                ))
              )}
            </tbody>

              </table>
            </div>
          </div>
           <Pagination
              page={page}
              limit={limit}
              total={total}
              onPageChange={(newPage) => setPage(newPage)}
              showAlways={true}
            />

        </div>
      </div>
    </section>
  );
};

export default Reviews;
